import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from '@/features/Home/HomePage';
import NotFoundPage from '@/features/NotFound/NotFoundPage';
import TermsOfServicePage from '@/features/Legal/TermsOfServicePage';
import PrivacyPolicyPage from '@/features/Legal/PrivacyPolicyPage';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};
